module.exports = __webpack_public_path__ + "img/arrow-up.2fbfc9ae.png";